import { handleActions } from 'redux-actions';

export const defaultCommunityData = {
	id: 1,
	name: 'Name_1',
	email: 'zone@25sprout.com',
	gender: 'MALE',
	nickname: 'NickName_1',
	career: '程序猿AA',
	ig_media: [],
	city_id: 13,
	image: 'u',
	intro:
		'努力裝成熟的威士忌漢子，暢談他們與酒作伴的人生。努力裝成熟的威士忌漢子，暢談他們與酒作伴的人生。 努力裝成熟的威士忌漢子，暢談他們與酒作伴的人生。努力裝成熟的威士忌漢子，暢談他們與酒作伴的人生。',
	image_url: 'https://9floorco-living.25demo.com/backend/web/user/u',
	songs: [],
	job_types: [],
	professions: [
		{
			id: 1,
			name: '專業_KPB4D',
			user_id: null,
			order: 9,
			created_at: '2018-07-18 15:15:39',
			updated_at: '2018-07-18 15:15:39',
			pivot: {
				user_id: 15,
				profession_id: 1,
			},
		},
	],
	social_media: [],
	interests: [
		{
			id: 3,
			name: '興趣_zgHhl',
			user_id: '1',
			pivot: {
				user_id: 15,
				interest_tag_id: 3,
			},
		},
	],
};

export const defaultCommunitySearchData = {
	keyword: { value: '', status: '', valid: false },
	city: { value: [], list: [], data: {}, status: '', valid: false },
};

export default handleActions(
	{
		FETCH_COMMUNITY_FULFILLED: (state, action) => ({
			...state,

			list: action.payload.list,
			data: { ...state.data, ...action.payload.data },
			currentPage: action.payload.currentPage,
			lastPage: action.payload.lastPage,
		}),

		FETCH_MORE_COMMUNITY_FULFILLED: (state, action) => ({
			...state,

			list: [...state.list, ...action.payload.list],
			data: { ...state.data, ...action.payload.data },
			currentPage: action.payload.currentPage,
			lastPage: action.payload.lastPage,
		}),

		UPDATE_COMMUNITY_FIELD: (state, action) => ({
			...state,

			[action.payload.type]: {
				...state[action.payload.type],
				[action.payload.key]: {
					...state[action.payload.type][action.payload.key],
					...action.payload.value,
				},
			},
		}),

		FETCH_COMMUNITY_CITY_FULFILLED: (state, action) => ({
			...state,

			search: {
				...state.search,

				city: {
					...state.search.city,
					...action.payload,
				},
			},
		}),
	},
	{
		list: [],
		data: {},
		currentPage: -1,
		lastPage: -1,

		search: defaultCommunitySearchData,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/community.js